import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from "../services/auth.service";
import { RouteInformation } from 'src/app/shared/constants/route-information';

@Injectable({
  providedIn: 'root'
})

export class PrevAuthGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    if (state.url === RouteInformation.unauthorizedPage) {
      return true;
    }

    const user = this.authService.storagedUser;
    /**
     * Validation for login
    **/
    if (user === null && (state.url === RouteInformation.loginPage ||
      state.url === RouteInformation.signupPage ||
      state.url.split('?')[0] === RouteInformation.recoverPasswordPage)) {
      return true;
    }
    if (user !== null && state.url === RouteInformation.loginPage) {
      this.router.navigate([RouteInformation.registerPage]);
    }
    if (user === null && state.url !== RouteInformation.loginPage
      && state.url.split('?')[0] !== RouteInformation.recoverPasswordPage) {
      this.router.navigate([RouteInformation.loginPage]);
    }
    /**
     * Validation for register
    **/
    if (user !== null && user.isNew && state.url === RouteInformation.registerPage) {
      return true;
    }
    if (user !== null && !user.isNew && state.url === RouteInformation.registerPage) {
      this.router.navigate([RouteInformation.dashboardPage]);
    }
    if (user !== null && user.isNew && state.url !== RouteInformation.registerPage) {
      this.router.navigate([RouteInformation.registerPage]);
    }
    return false;
  }

}